import { createAsyncThunk } from '@reduxjs/toolkit';

import { Instances } from './Instances';
import { networkCall } from '../../utils/network-call';

import type { InstanceType} from './Instances';

interface RequestDataParams {
  instanceType: InstanceType;
  baseUrl?: string;
  includeId?: boolean;
  header?: boolean;
  data?: any;
  instanceId?: any;
  config?: any;
  fullResponse?: boolean;
  customHeaders?: any;
  dataKey?: string; // Key in the response object that contains the array data
  dynamicUrlData?: string;
  replaceableUrlData?: Record<string, string>;
}

// Async thunk for loading data
export const requestData = createAsyncThunk(
  'instances/requestData',
  async (
    {
      instanceType,
      baseUrl = '',
      includeId = true,
      header = true,
      data,
      instanceId,
      config,
      fullResponse,
      customHeaders,
      dataKey = 'items', // Default to 'items' if not specified
      dynamicUrlData = '',
      replaceableUrlData = {}
    }: RequestDataParams,
    { rejectWithValue }
  ) => {
    try {
      const responseData = await networkCall(
        'GET',
        Instances[instanceType].endpoint,
        baseUrl,
        includeId,
        header,
        data,
        instanceId,
        config,
        fullResponse,
        customHeaders,
        dynamicUrlData,
        replaceableUrlData
      );
      return { instanceType, data: responseData, dataKey };
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  }
);



// Async thunk for changing offset
export const changeOffset = createAsyncThunk(
  'instances/changeOffset',
  //TODO: Not all params are needed to be passed here again, fetch the existing state 
  // TODO:in reducer with the help of instanceType and use the same. 
  async (
    { 
      instanceType, 
      newOffset,
      dataKey = 'items',
      baseUrl = '',
      includeId = true,
      header = true,
      data,
      instanceId,
      config,
      fullResponse,
      customHeaders,
      dynamicUrlData = '',
      replaceableUrlData = {}
    }: RequestDataParams & { newOffset: number },
    { rejectWithValue }
  ) => {
    try {
      const responseData = await networkCall(
        'GET',
        `${Instances[instanceType].endpoint}?offset=${newOffset}`,
        baseUrl,
        includeId,
        header,
        data,
        instanceId,
        config,
        fullResponse,
        customHeaders,
        dynamicUrlData,
        replaceableUrlData
      );
      return { instanceType, data: responseData, newOffset, dataKey };
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  }
); 
